import { useDayPicker } from 'react-day-picker';

import { Button } from '@/components/common';

export const CustomFooter = () => {
  const dayPicker = useDayPicker();

  const goToCurrent = () => {
    const today = new Date();
    dayPicker.goToMonth(today);
  };

  return (
    <div className="flex justify-center">
      <Button
        buttonColor="primary"
        buttonStyle="outline"
        size="sm"
        onClick={goToCurrent}
        className="font-semibold text-body-sm !text-primary-base border-none !rounded-none h-[22px] mt-2"
      >
        Today
      </Button>
    </div>
  );
};
